import {PersonOutline, MailOutline, SchoolOutlined, WorkOutlined, Schedule, StarOutline, Check} from 'views/icons';

const shiftOptions = [
  'morning',
  'afternoon',
  'evening',
  'night',
  'unavailable',
];

export default {
  CategoryIcons: {
    personalInfo: PersonOutline,
    contactInfo: MailOutline,
    workQuali: SchoolOutlined,
    workExperience: WorkOutlined,
    availability: Schedule,
    skillsAndPrefs: StarOutline,
    agreements: Check,
  },
  Questions: {
    personalInfo: [
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'name',
      },
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'currentCity',
      },
      {
        fieldType: 'location',
        questionData: {
          latitude: 0,
          longitude: 0,
        },
        bioQuestionId: 'homeLocation',
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'languagesSpoken',
        questionData: {
          value: [],
          options: [
            'english',
            'french',
            'spanish',
            'igbo',
            'portugese',
            'italian',
            'greek',
            'hindi',
            'punjabi',
            'mandarin',
            'cantonese',
          ],
        },
      },
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'shortBio',
      },
      {
        fieldType: 'long_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'personalBio',
      },
      {
        fieldType: 'long_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'caregiverMotivation',
      },
      {
        fieldType: 'file',
        questionData: {
          value: [],
        },
        bioQuestionId: 'profilePhoto',
      },
    ],
    contactInfo: [
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'email',
      },
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'phoneNumber',
      },
      {
        fieldType: 'array',
        questionData: {
          schema: {
            name: 'short_text',
            relationship: 'short_text',
            phoneNumber: 'short_text',
          },
          value: [],
        },
        bioQuestionId: 'emergencyContacts',
      },
    ],
    workQuali: [
      {
        fieldType: 'single_select',
        bioQuestionId: 'caregiverType',
        questionData: {
          value: '',
          options: [
            'PSW',
            'DSW',
            'nursingStudent',
            'unaccredited',
          ],
        },
      },
      {
        fieldType: 'file',
        questionData: {
          value: [],
        },
        bioQuestionId: 'educationCertificate',
      },
      {
        fieldType: 'long_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'otherCertifications',
      },
      {
        fieldType: 'file',
        questionData: {
          value: [],
        },
        bioQuestionId: 'vulnerableSectorCheck',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: true,
        },
        bioQuestionId: 'certified',
      },
    ],
    workExperience: [
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'yearsOfExperience',
      },
      {
        fieldType: 'long_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'professionalBio',
      },
      {
        fieldType: 'file',
        questionData: {
          value: [],
        },
        bioQuestionId: 'resume',
      },
      {
        fieldType: 'array',
        questionData: {
          schema: {
            name: 'short_text',
            phoneNumber: 'short_text',
            relationship: 'short_text',
            email: 'short_text',
          },
          value: [],
        },
        bioQuestionId: 'references',
      },
    ],
    availability: [
      {
        fieldType: 'multi_select',
        bioQuestionId: 'mondayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'tuesdayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'wednesdayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'thursdayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'fridayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'saturdayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
      {
        fieldType: 'multi_select',
        bioQuestionId: 'sundayShifts',
        questionData: {
          value: [],
          options: shiftOptions,
        },
      },
    ],
    skillsAndPrefs: [
      {
        fieldType: 'five_star',
        questionData: {
          value: 3,
        },
        bioQuestionId: 'cookingSkills',
      },
      {
        fieldType: 'five_star',
        questionData: {
          value: 3,
        },
        bioQuestionId: 'housekeepingSkills',
      },
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'prefRateOfPay',
      },
      {
        fieldType: 'short_text',
        questionData: {
          value: '',
        },
        bioQuestionId: 'minDesiredShiftLength',
      },
      {
        fieldType: 'single_select',
        questionData: {
          value: '',
          options: [
            '5km',
            '10km',
            '25km',
            '50km',
            'over50',
          ],
        },
        bioQuestionId: 'commutePref',
      },
    ],
    agreements: [
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'termsAgreement',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'certifiesTruthfulness',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'understandsPrivacyAndAgreesToConfidentialityPolicies',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'certifiesValidAndUpToDateCertifications',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'understandsAbuseProhibition',
      },
      {
        fieldType: 'checkbox',
        questionData: {
          value: false,
        },
        bioQuestionId: 'committedToCodeOfConductAndEthics',
      },
    ],
  },
};
